import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';

export enum AutoSaveStatus {
	SAVING = 'saving',
	SAVED = 'saved',
	ERROR = 'error',
}

export const statusConfig: Record<
	AutoSaveStatus,
	{ text: string; color: string; animate: boolean }
> = {
	[AutoSaveStatus.SAVING]: {
		text: 'saving...',
		color: defaultTheme.v3.colors.teal[9],
		animate: true,
	},
	[AutoSaveStatus.SAVED]: {
		text: 'autosaved',
		color: defaultTheme.v3.colors.teal[9],
		animate: false,
	},
	[AutoSaveStatus.ERROR]: {
		text: 'error',
		color: defaultTheme.v3.colors.red[8],
		animate: false,
	},
};
